<div class="loading-animation"><div></div><div></div><div></div></div>
<div class="backdrop"></div>